import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { COUNTRY_LANGUAGE_MAP } from 'main_app/enums/country-language';

@Component({
    selector: 'app-language-switcher',
    templateUrl: './language-switcher.component.html',
    styleUrls: ['./language-switcher.component.less']
})
export class LanguageSwitcherComponent implements OnInit {

    selectedLanguage: string = '';
    isDropdownOpen = false;

    availableLanguages = [
        { code: 'en', label: 'English', flag: 'assets/flags/gb.png' },
        { code: 'zh', label: 'Chinese (Simplified)', flag: 'assets/flags/cn.png' },
        { code: 'nl', label: 'Dutch', flag: 'assets/flags/nl.png' },
        { code: 'fr', label: 'French', flag: 'assets/flags/fr.png' },
        { code: 'de', label: 'German', flag: 'assets/flags/de.png' },
        { code: 'it', label: 'Italian', flag: 'assets/flags/it.png' },
        { code: 'pt', label: 'Portuguese', flag: 'assets/flags/pt.png' },
        { code: 'ru', label: 'Russian', flag: 'assets/flags/ru.png' },
        { code: 'es', label: 'Spanish', flag: 'assets/flags/es.png' }
    ];

    constructor(
        public translateService: TranslateService,
        private http: HttpClient
    ) { }

    ngOnInit(): void {
        this.selectedLanguage = localStorage.getItem('language') || '';
        this.translateService.use(this.selectedLanguage);

        if (this.selectedLanguage) {
            this.setLanguage(this.selectedLanguage);
        } else {
            this.detectLanguageByIP();
        }
    }

    setLanguage(lang: string): void {
        this.selectedLanguage = lang;
        this.translateService.setDefaultLang(lang);
        this.translateService.use(lang);
        localStorage.setItem('language', lang);
    }

    detectLanguageByIP(): void {
        this.http.get<any>('https://ipwho.is/', {
            headers: new HttpHeaders({ 'skipInterceptor': 'true' })
        }).subscribe({
            next: (response) => {
                const selectedLang = COUNTRY_LANGUAGE_MAP[response.country_code] ? COUNTRY_LANGUAGE_MAP[response.country_code] : 'en';
                this.setLanguage(selectedLang);
            },
            error: () => {
                this.setLanguage('en');
            }
        });
    }

    toggleDropdown(): void {
        this.isDropdownOpen = !this.isDropdownOpen;
    }

    selectLanguage(langCode: string, event: Event): void {
        event.stopPropagation();
        this.selectedLanguage = langCode;
        localStorage.setItem('language', this.selectedLanguage);
        this.translateService.use(this.selectedLanguage);
        this.isDropdownOpen = false;
    }

    // Get flag URL for the given language code
    getFlag(langCode: string): string {
        return this.availableLanguages.find(lang => lang.code === langCode)?.flag || '';
    }

    // Get language label for the selected language
    getLanguageLabel(langCode: string): string {
        return this.availableLanguages.find(lang => lang.code === langCode)?.label || '';
    }
}
